import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { OpendialogAddEditTraineeComponent } from 'app/components/dialog/open-dialog-add-edit-trainee/opendialog-add-edit-trainee.component';
import { OpenDialogAddEditUserComponent } from 'app/components/dialog/open-dialog-add-edit-user/open-dialog-add-edit-user.component';
import { OpenDialogAddOfferCounterComponent } from 'app/components/dialog/open-dialog-add-offer-counter/open-dialog-add-offer-counter.component';
import { OpenDialogConfirmBookedComponent } from 'app/components/dialog/open-dialog-confirm-booked/open-dialog-confirm-booked.component';
import { OpenDialogConfirmUpdateBookingComponent } from 'app/components/dialog/open-dialog-confirm-update-booking/open-dialog-confirm-update-booking.component';
import { OpendialogCustomizeMySessionComponent } from 'app/components/dialog/open-dialog-customize-my-session/opendialog-customize-my-session.component';
import { OpenDialogInConstructionComponent } from 'app/components/dialog/open-dialog-in-construction/open-dialog-in-construction.component';
import { OpenDialogPaymentRefundComponent } from 'app/components/dialog/open-dialog-payment-refund/open-dialog-payment-refund.component';
import { BasketWithPrice, BookBasketOffer, SelectBasketOffer, SessionList } from 'app/shared/models/class/basket/basketList';
import { BookedSessionByBookingKey, BookingUser } from 'app/shared/models/class/booking-session/booking-session';
import { PaymentRefundGlobal, ResultSearchEngine, SelectCounterSessionBasketOffer, SelectCounterSessionBasketOfferString } from 'app/shared/models/class/counter/counter';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferSession } from 'app/shared/models/class/session/session';
import { BookSessionBasket } from 'app/shared/models/class/systempay/systeme';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { CustomerCounter } from 'app/shared/models/class/user/user';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { BookingSessionService } from 'app/shared/services/booking-session/booking-session.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { CounterService } from 'app/shared/services/counter/counter.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { PdfService } from 'app/shared/services/pdf/pdf.service';
import { ReportService } from 'app/shared/services/report/report.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { TraineeService } from 'app/shared/services/trainee/trainee.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-admin-counter-new-booking',
  templateUrl: './admin-counter-new-booking.component.html',
  styleUrls: ['./admin-counter-new-booking.component.scss']
})
export class AdminCounterNewBookingComponent implements OnInit {


  newBookingForm: UntypedFormGroup;
  basket: FullOffer[] = [];
  userConnected: any;
  trainees: Trainee[] = [];
  customers: CustomerCounter[];
  myControl = new UntypedFormControl();
  filteredOptions: Observable<CustomerCounter[]>;
  customersFiltered: CustomerCounter[] = [];
  customer: CustomerCounter;
  tab = 'basketInProgress';
  clubCode: any;
  bookingUser: BookingUser[];

  bookingCustomerForm: UntypedFormGroup;
  sessionBooking: BookedSessionByBookingKey[];

  color: ThemePalette = 'primary';
  valueInput: string;
  quantitySelectedByUser: number;
  offerAddToPayment: any;
  basketWithPrice: BasketWithPrice;
  licences: any;
  totalPrice: number;
  totalDiscount: object;
  authoToClick = true;
  updateBasketBooked = false;
  sessionBookingCounter: any;
  booking: BookingUser;
  showResultSearch = false;

  searchAdvancedForm: UntypedFormGroup;
  tabsSearch: string[];
  tabsSearchActive: string;
  resultSearch: ResultSearchEngine[];
  bookingSelected: ResultSearchEngine;
  paymentRefundList: PaymentRefundGlobal;

  isLoadingExport = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private authService: AuthService,
    private traineeService: TraineeService,
    private clubService: ClubService,
    private route: ActivatedRoute,
    private bookingSessionService: BookingSessionService,
    private tooltip: TooltipService,
    private imgOfferDefault: ImgOfferDefaultService,
    private sessionBasketService: SessionBasketService,
    private uiService: UiService,
    private dataService: DataService,
    private counterService: CounterService,
    private pdfService: PdfService,
    private cdr: ChangeDetectorRef,
    private faIconService: FaiconService,
    private reportsService: ReportService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getImgUrl(offer: FullOffer): string {
    return !offer.image?.includes('data') ? `${environment.apiUrl}/images/${offer.image}` : this.imgOfferDefault.imgDefault;
  }

  openDialogAddOfferToCounter(): void {
    const dialogRef = this.dialog.open(OpenDialogAddOfferCounterComponent, {
      data: { basket: this.basket, customerKey: this.customer.userKey },
      width: '100%',
      height: '85%'
    });

    dialogRef.afterClosed().subscribe({
      next: () => this.getShoppingBagByUser(this.customer.userKey)
    });
  }

  deleteInMyShoppingBag(offer: FullOffer): void {
    const index = this.basket.findIndex(o => o.offerKey === offer.offerKey);
    this.basket.splice(index, 1);

    this.sessionBasketService.deleteSessionBasketInMyBasket(this.customer.userKey, +offer.sessionBasketKey).subscribe({
      next: () => this.getShoppingBagByUser(this.customer.userKey)
    });

  }

  openDialogAddOrEditTrainee(action: string, trainee?: Trainee) {
    const dialogRef = this.dialog.open(OpendialogAddEditTraineeComponent, {
      data: { action, trainee, userKey: this.customer.userKey },
      minWidth: '50%',
      height: '80%'
    });

    dialogRef.afterClosed().subscribe({
      next: () => {

        this.getTrainees(this.customer.userKey);
        this.getPricingBasket(this.tab);
        this.getShoppingBagByUser(this.customer.userKey);
      }
    });
  }

  resetEmail(): void {
    this.myControl.reset();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    this.newBookingForm.reset();
    this.trainees = [];
    this.bookingUser = [];
    this.valueInput = undefined;
    this.basket = [];
    this.offerAddToPayment = [];
    this.tab = 'basketInProgress';
    this.updateBasketBooked = false;
    this.totalPrice = 0;
    this.showResultSearch = false;
  }

  async changeTab(tab: string, search: boolean = false) {
    if (search) {
      this.tabsSearchActive = tab;

    } else {
      this.tab = await tab;

      switch (this.tab) {
        case 'basketInProgress':
          this.getShoppingBagByUser(this.customer.userKey);
          break;

        case 'basket':
          this.licences = [];
          this.bookingSelected = null;
          await this.getBookingByUserAndByClub(this.customer.userKey);
          this.initOfferAddToPayment();
          // this.getPricingBasket('basket')
          break;

        default:
          break;
      }
    }
  }

  changeBookingOverview(booking: BookingUser): void {
    this.licences = [];
    this.booking = booking;
    this.getPaymentRefundList(this.booking.bookingKey);
    this.getSessionsByBooking(booking.bookingKey);
  }

  calSum(): number {
    const arrayToSum = this.tab !== 'basket' ? [0] : this.sessionBooking?.map(s => s.bookedSessionAmount);
    const reducer = (previousValue, currentValue) => previousValue + currentValue;
    return arrayToSum?.reduce(reducer) || 0;
  }

  displayFn(customer: CustomerCounter): string {
    return this.valueInput === '' || this.valueInput !== undefined ? this.valueInput : customer?.email;
  }

  setValueInput(keyword: string): void {
    this.valueInput = keyword;
  }

  searchAdvance(): void {
    this.showResultSearch = true;
    this.fSearchAdvanced.keyword.setValue(this.valueInput);
    this.submitSearchAdvance();
    const user = { email: 'null', firstName: null, lastName: null, userKey: null };
    this.customer = new CustomerCounter(user);
    this.cdr.detectChanges();
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  opendialogCustomizeMySession(offer: any): void {
    const quantity = this.quantitySelectedByUser || offer.traineeQuantity;
    const dialogRef = this.dialog.open(OpendialogCustomizeMySessionComponent, {
      data: {
        offer,
        quantity,
        showError: false,
        userKey: this.customer.userKey,
        counterSessionBasketKey: offer.counterSessionBasketKey,
        sessionKey: offer.sessionKey
      },
      minWidth: '50%',
      width: '100%',
      height: '80%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        if (!this.updateBasketBooked) {
          this.getShoppingBagByUserFetch();
          this.dataService.paramsOfferIsComplete$.next(false);
        } else {
          this.getCounterSessionBasket(this.userConnected.sub, this.customer.userKey);
        }
      }
    });
  }

  getNewValueOfQuantity(event, counterSessionBasketKey?: number): void {
    this.quantitySelectedByUser = event.traineeQuantity;
    switch (this.tab) {
      case 'basketInProgress':
        this.sessionBasketService.UpdateQuantityBasketOffer(event).subscribe({
          next: () => {
            const checkSession = new SelectBasketOffer(this.customer.userKey, event.sessionBasketKey);
            this.sessionBasketService.checkSessionBasketComplete(checkSession).subscribe({
              next: () => this.getShoppingBagByUserFetch()
            });
          }
        });
        break;

      case 'basket':
        const update = event;
        update.counterSessionBasketKey = counterSessionBasketKey;
        update.counterUserKey = this.authService.getDecodedToken().sub;
        update.userKey = this.customer.userKey;
        this.counterService.updateCounterTraineeQuantity(update).subscribe({
          next: () => {
            const { counterSessionBasketKey, counterUserKey } = event;
            const checkSession = new SelectCounterSessionBasketOffer(counterSessionBasketKey, counterUserKey, this.userConnected.sub);
            this.counterService.checkCounterSessionBasketComplete(checkSession).subscribe({
              next: () => this.getCounterSessionBasket(this.userConnected.sub, this.customer?.userKey)
            });
          }
        });
        break;

      default:
        break;
    }
  }

  getNewSelectedSession(sessionSelected, offer) {
    offer.sessionKey = sessionSelected.sessionKey;
    if (!this.updateBasketBooked) {
      this.getShoppingBagByUserFetch();
      this.dataService.paramsOfferIsComplete$.next(false);
    } else {
      this.getCounterSessionBasket(this.userConnected.sub, this.customer.userKey);
    }
  }


  getMessageAddOfferToPaiment(): void {
    this.uiService.showSnackbar('Vous devez selectionner l\'offre pour réaliser cette action');
  }

  getStatuPriceOfOffer(offer: FullOffer, i: number): string {
    let status = 'Non personnalisée';

    status = offer?.isComplete && offer?.isSelected && this.offerAddToPayment?.length ?
      `${this.offerAddToPayment[i]?.sessionTotalPrice}€` : '';

    return status;
  }

  getSessionOfferBasket(offerBasket: FullOffer): OfferSession {
    return offerBasket.sessions?.find(o => o.sessionKey === offerBasket.sessionKey);
  }

  noOfferInBasket(): FullOffer[] {
    return this.offerAddToPayment?.filter(el => el.isSelected);
  }

  getOfferAddToPayment(offerAddToPayment: FullOffer[]): FullOffer[] {
    const basketOfferKeysMyShoppingBag = this.basket.map(o => o.sessionBasketKey);
    const result = this.basket.filter(o1 => !offerAddToPayment.some(o2 => o1.sessionBasketKey === o2.sessionBasketKey));
    const newOfferAddToPayment = [...offerAddToPayment, ...result];

    return newOfferAddToPayment.sort((a, b) => {
      const aValue = basketOfferKeysMyShoppingBag.indexOf(Object.values(a)[0]);
      const bValue = basketOfferKeysMyShoppingBag.indexOf(Object.values(b)[0]);
      return aValue - bValue;
    });
  }

  bookOffer(): void {
    this.authoToClick = false;

    const offerAddToPaymentFiltered = [...this.offerAddToPayment.filter(o => o.isComplete && o.isSelected), ...this.licences];
    const basketOffer: string[] = offerAddToPaymentFiltered.map((o, i) => o.offerKey.toString());
    const uniqueBasketOffer = [...new Set(basketOffer)];

    const sessionsList: SessionList[] = offerAddToPaymentFiltered.map((el) => {
      return {
        sessionBasketKey: el.sessionBasketKey,
        sessionTotalPrice: el.sessionTotalPrice
      };
    });

    const total = this.basketWithPrice.grandDiscount > 0 ? this.basketWithPrice.discountedGrandTotal : this.basketWithPrice.grandTotal;
    const myOrder = new BookBasketOffer(this.customer.userKey, uniqueBasketOffer, total, sessionsList);

    // this.openDialogConfirmBooked(myOrder, this.offerAddToPayment);
    this.openDialogAddPaymentDefund('Ajouter un paiement', 'payment', myOrder);
  }

  openDialogConfirmBooked(myOrder: BookBasketOffer, offers: FullOffer[]): void {
    const dialogRef = this.dialog.open(OpenDialogConfirmBookedComponent, {
      data: { myOrder, offers },
      height: '40%'
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.getShoppingBagByUser(this.customer.userKey);
        this.authoToClick = true;
      }
    });
  }

  checkAddToPayment(offer: FullOffer): boolean {
    const listClubCode = this.offerAddToPayment.filter(o => o.isSelected && o.clubCode).map(o => o.clubCode);
    const check = offer.clubCode === listClubCode[0] || !listClubCode.length ? true : false;
    if (!check) {
      this.uiService.showSnackbar('Vous ne pouvez pas ajouter une offre d\'un club différent dans votre panier');
    }

    return offer.clubCode === listClubCode[0] || !listClubCode.length ? true : false;
  }

  addToPayment(offer): void {
    // const selection = new SelectBasketOffer(this.customer.userKey, offer.sessionBasketKey, !offer.isSelected);
    const selection = {
      counterSessionBasketKey: offer.counterSessionBasketKey,
      counterUserKey: this.authService.getDecodedToken().sub,
      userKey: this.customer.userKey,
      isSelected: !offer.isSelected
    }

    setTimeout(() => {
      this.counterService.selectCounterSessionBasketOffer(selection).subscribe({
        next: () => this.getShoppingBagByUser(this.customer.userKey, 'selection')
      });
    });
  }

  allMyOffersIsComplete(): boolean {
    const isAllComplete = this.offerAddToPayment?.filter(o => o.isComplete && o.isSelected);
    const isSelected = this.offerAddToPayment?.filter(o => o.isSelected);
    return (isAllComplete?.length === isSelected?.length) && isSelected?.length ? true : false;
  }

  openDialogInContruction(text: string) {
    this.dialog.open(OpenDialogInConstructionComponent, {
      data: { text },
      height: '50%',
      width: '50%'
    });
  }

  openDialogAddPaymentDefund(title: string, action: string, myOrder?: BookBasketOffer): void {
    const dialogRef = this.dialog.open(OpenDialogPaymentRefundComponent, {
      data: { title, tab: this.tab, action, booking: this.booking, paymentRefundList: this.paymentRefundList, myOrder },
      width: '50%'
    });

    dialogRef.afterClosed().subscribe({
      next: res => {

        switch (res?.tab) {
          case 'basketInProgress':
            this.authoToClick = true;
            // this.getShoppingBagByUser(this.customer.userKey);
            // this.getBookingByUserAndByClub(this.customer.userKey, true);
            this.changeTab('basket');

            break;
          case 'basket':
            if (res.bookingKey) {
              this.getPaymentRefundList(res.bookingKey);
            }
            this.getBookingByUserAndByClub(this.customer.userKey);

            break;

          default:
            break;
        }
      }
    });
  }

  openDialogAddEditUser(action: string): void {
    const dialogRef = this.dialog.open(OpenDialogAddEditUserComponent, {
      data: { action }
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.getCustomersByClub();
      }
    });
  }

  updateBooking(cancel: boolean = false) {
    if (!cancel) {
      const dialogRef = this.dialog.open(OpenDialogConfirmUpdateBookingComponent, {
        data: { price: this.booking.bookingAmount },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe({
        next: res => {
          if (!res) {
            this.updateBasketBooked = res;
            this.licences = [];
          } else {
            this.updateBasketBooked = res;
            this.licences = [];
            this.createCounterBasketSession(this.userConnected.sub, this.sessionBooking[0]?.bookedSessionKey);
          }
        }
      });

    } else {
      this.updateBasketBooked = false;
      this.licences = [];
      this.getSessionsByBooking(this.fBookingForm.booking.value.bookingKey);
    }
  }

  getCounterSessionBasketUpdate(): void {
    this.getCounterSessionBasket(this.userConnected.sub, this.customer.userKey);
  }

  // version copié depuis my-shopping-bag
  newBookOffer(): void {

    this.authoToClick = false;

    const offerAddToPaymentFiltered = [...this.offerAddToPayment.filter(o => o.isComplete && o.isSelected), ...this.licences];
    const basketOffer: string[] = offerAddToPaymentFiltered.map((o, i) => o.offerKey.toString());
    const uniqueBasketOffer = [...new Set(basketOffer)];

    const sessionsList: SessionList[] = offerAddToPaymentFiltered.map((el) => {
      return {
        sessionBasketKey: el.counterSessionBasketKey,
        sessionTotalPrice: el.sessionTotalPrice
      };
    });

    const total = this.basketWithPrice.grandDiscount > 0 ? this.basketWithPrice.discountedGrandTotal : this.basketWithPrice.grandTotal;
    const myOrder = new BookBasketOffer(this.customer.userKey, uniqueBasketOffer, total, sessionsList);
    myOrder.counterUserKey = this.authService.getDecodedToken().sub;
    myOrder.bookingKey = this.fBookingForm.booking.value.bookingKey;

    this.counterService.validateBasketCounter(myOrder).subscribe({
      next: () => {
        this.licences = [];
        this.updateBasketBooked = false;
        this.getBookingByUserAndByClub(this.customer.userKey);
        this.initOfferAddToPayment();
      }
    });

  }

  updateSessionBasketPriceByMau() {
    this.getCounterSessionBasketUpdate();
  }

  applyCounterBasket(): void {
    this.newBookOffer();
  }

  exportPdfBill(): void {
    if (this.fBookingForm?.booking?.value?.bookingKey) {
      this.pdfService.getPdfBookedSession(this.fBookingForm.booking.value.bookingKey).subscribe({
        next: blob => {
          const data = window.URL.createObjectURL(<any>blob.body);
          const anchor = document.createElement('a');
          anchor.href = data;
          anchor.download = `Facture n° ${this.fBookingForm.booking.value.bookingReference}.pdf`;
          anchor.click();

          setTimeout(() => {
            window.URL.revokeObjectURL(data);
          }, 100);
        }
      });
    }
  }

  exportPaymentFollow() {
    this.isLoadingExport = true;
    this.reportsService.getPayementsCounter(this.clubCode).subscribe(
      {
        next: result => {
          this.isLoadingExport = false;
        },
        error: error => {
          console.log('error', error)
          this.isLoadingExport = false;
        }
      }
    );
  }

  closeSearch(): void {
    this.showResultSearch = false;
  }

  submitSearchAdvance(): void {
    this.counterService.counterSearchEngine(this.valueInput, this.clubCode).subscribe({
      next: resultSearch => {
        this.resultSearch = resultSearch;
        this.tabsSearch = [...new Set(resultSearch.map(r => r.type))];
        this.tabsSearchActive = this.tabsSearch[0];
      }
    });
  }

  getTitleTabSearch(tab: string): string {

    const title = {
      Invoice: 'Facture(s)',
      OfferKey: 'Offre(s)'
    };

    return title[tab];
  }

  async setBookingSelected(event: ResultSearchEngine) {
    this.bookingSelected = await event;
    const customer = await this.customers.find(c => c.userKey === event.userKey);
    this.tab = 'basket';
    this.valueInput = customer?.email;
    this.myControl.setValue(customer);
    this.showResultSearch = false;
    this.initOfferAddToPayment();
    this.cdr.detectChanges();
  }

  private async initOfferAddToPayment() {
    this.offerAddToPayment = await [];
    const offerBasket = await this.sessionBooking?.map(o => o.offer);
    this.offerAddToPayment = await offerBasket?.filter(o => !o.isLicence);
    this.licences = await offerBasket?.filter(o => o.isLicence);
    // this.getPricingBasket('basket')
  }

  private createCounterBasketSession(userKey: number, bookedSessionKey: number): void {
    this.counterService.createCounterBasketSession(userKey, bookedSessionKey).subscribe({
      next: () => {
        this.getCounterSessionBasket(this.userConnected.sub, this.customer?.userKey);
      }
    });
  }

  private getCounterSessionBasket(customerUserKey: number, userKey): void {
    this.counterService.getCounterSessionBasket(customerUserKey, userKey).subscribe({
      next: res => {
        this.sessionBookingCounter = [];
        this.sessionBookingCounter = res;
        this.getPricingBasket(this.tab);
      }
    });
  }

  private getTrainees(userKey: number, fetchCall: boolean = false): void {
    this.traineeService.getTrainees(userKey).subscribe({
      next: trainees => this.trainees = trainees
    });
  }

  private getCustomersByClub(): void {
    this.clubService.getCustomersByClub(this.clubCode).subscribe({
      next: customers => {
        this.customers = customers;

        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      }
    });
  }

  private getPricingBasket(basket: string): void {
    switch (basket) {
      case 'basketInProgress':
        this.sessionBasketService.getPriceSession(this.customer?.userKey).subscribe({
          next: basketWithPrice => {
            this.basketWithPrice = basketWithPrice;
            const offer = this.getOfferAddToPayment([...basketWithPrice?.fullOfferList]);
            this.offerAddToPayment = offer.filter(o => !o.isLicence);
            this.licences = offer.filter(o => o.isLicence);
            this.checkCodePromo(this.offerAddToPayment);
            this.totalPrice = basketWithPrice.grandTotal;
            // const clubCode = [... new Set(basketWithPrice.fullOfferList.map(o => o.clubCode))][0];
          }
        });
        break;

      case 'basket':
        this.counterService.getCounterPriceOffer(this.userConnected.sub, this.customer.userKey).subscribe({
          next: async basketWithPrice => {
            this.offerAddToPayment = [];
            this.licences = [];
            this.basketWithPrice = basketWithPrice;
            const { fullOfferCounterList } = await basketWithPrice;
            this.offerAddToPayment = fullOfferCounterList?.filter(o => !o.isLicence);
            this.licences = fullOfferCounterList?.filter(o => o.isLicence);
            this.totalPrice = basketWithPrice.grandTotal;
            // const clubCode = [... new Set(basketWithPrice.fullOfferCounterList.map(o => o.clubCode))][0];
          }
        });
        break;

      default:
        break;
    }
  }

  private checkCodePromo(basket: FullOffer[]): boolean {
    const basketFilter = basket.filter(o => o.isSelected);
    const offerKeys = basketFilter.map(o => o.offerKey);
    const offerKeyBase = offerKeys[0];
    return offerKeys.every(o => o === offerKeyBase) && basketFilter.every(o => o.isComplete);
  }

  private getBookingByUserAndByClub(userKey: number, init: boolean = false): void {
    console.log("getBookingByUserAndByClub");
    console.log("userKey", userKey);
    console.log("init", init);
    console.log("this.bookingSelected", this.bookingSelected);
    this.bookingSessionService.getBookingByUserAndByClub(userKey, this.clubCode).subscribe({
      next: bookingUser => {
        this.bookingUser = bookingUser.reverse();

        if (!init && !this.bookingSelected) {
          this.booking = this.bookingUser[0] || null;

          if (this.bookingUser?.length) {
            this.fBookingForm.booking.setValue(this.bookingUser[0]);
            this.getSessionsByBooking(this.bookingUser[0]?.bookingKey);
          }

        } else {
          this.booking = this.bookingUser?.find(b => b.bookingKey === this.bookingSelected?.bookingKey);
          this.fBookingForm.booking.setValue(this.booking);

          if (this.bookingUser?.length) {
            if (this.bookingSelected) {
              this.getSessionsByBooking(this.bookingSelected?.bookingKey);
            } else {
              this.getSessionsByBooking(this.bookingUser[0]?.bookingKey);
            }
          }
        }

        if (this.booking?.bookingKey) {
          this.getPaymentRefundList(this.booking?.bookingKey);
        }
      }
    });
  }

  private getSessionsByBooking(bookingKey: number): void {
    this.bookingSessionService.getSessionsByBooking(bookingKey).subscribe({
      next: sessionBooking => {
        this.sessionBooking = [];
        this.sessionBooking = sessionBooking;
        const offerBasket = [...sessionBooking?.map(o => o.offer)];
        this.licences = offerBasket?.filter(o => o.isLicence);
        // this.updateBasketBooked ?
        //   this.getCounterSessionBasket(this.userConnected.sub, this.customer.userKey) :
        //   this.createCounterBasketSession(this.userConnected.sub, this.sessionBooking[0]?.bookedSessionKey);
      }
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;
    this.getCustomersByClub();
  }

  private _filter(value: any): CustomerCounter[] {
    this.sessionBooking = [];
    this.bookingCustomerForm.reset();
    if (typeof value !== 'object') {
      const filterValue = value?.trim().toLowerCase();
      this.customersFiltered = this.customers.filter(c => JSON.stringify(c).toLowerCase().includes(filterValue));
    }

    this.customer = typeof value === 'object' ? value : this.customers.find(c => c === this.myControl.value);
    this.cdr.detectChanges();

    if (this.customer?.userKey) {
      this.f.email.setValue(this.customer.email);
      this.f.firstName.setValue(this.customer.firstName);
      this.f.lastName.setValue(this.customer.lastName);

      this.getTrainees(this.customer.userKey);

      switch (this.tab) {
        case 'basketInProgress':
          this.getShoppingBagByUser(this.customer.userKey);
          this.getBookingByUserAndByClub(this.customer.userKey, true);
          break;

        case 'basket':
          this.getBookingByUserAndByClub(this.customer.userKey);
          break;

        default:
          break;
      }
    }

    return this.customersFiltered;
  }

  private getShoppingBagByUser(userKey: number, type?: string): void {
    this.sessionBasketService.getBasketList(userKey).subscribe({
      next: basket => {
        this.basket = basket.sort((a, b) => {
          return (b.isSelected as any) - (a.isSelected as any);
        });
        this.getPricingBasket(this.tab);
      }
    });
  }

  private getShoppingBagByUserFetch(): void {
    fetch(`${environment.apiUrl}/SessionBasket/${this.customer.userKey} `, {
      method: 'get',
      headers: { authorization: `Bearer ${localStorage.getItem(`${environment.tokenKey}`)} ` }
    })
      .then(response => response.json())
      .then((response) => {
        this.basket = response.sort((a, b) => {
          return (b.isSelected as any) - (a.isSelected as any);
        });
        this.getPricingBasket(this.tab);
      })
      .catch((error) => { });
  }

  private getPaymentRefundList(bookingKey: number) {
    this.counterService.getPaymentRefundList(bookingKey).subscribe({
      next: paymentRefundList => {
        this.paymentRefundList = paymentRefundList;
      }
    });
  }

  get f() {
    return this.newBookingForm.controls;
  }

  get fBookingForm() {
    return this.bookingCustomerForm.controls;
  }

  get fSearchAdvanced() {
    return this.searchAdvancedForm.controls;
  }

  private initForm(): void {
    this.newBookingForm = this.formBuilder.group({
      email: [''],
      lastName: [''],
      firstName: [''],
    });

    this.f.email.disable();
    this.f.firstName.disable();
    this.f.lastName.disable();

    this.bookingCustomerForm = this.formBuilder.group({
      booking: [''],
    });

    this.searchAdvancedForm = this.formBuilder.group({
      keyword: ['']
    });
  }
}
